import styled from 'styled-components';

import { DawnTick } from '@xemplo/icons';
import { Colour, Shadow } from '@xemplo/style-constants';

import { TabMenuItem } from '../menu-item';

export { MenuItem } from '../menu-item/menu-item.styles';
/**
 * When is Primary, it means is the top navigation menu and therefore will always have
 * a fixed height of 80px and the submenu panel is aligned to 68px from the top.
 * As for the other sizes, the height is dependent on the parent container and the
 * submenu might need to receive custom top value. At this stage, just setting pre-defined
 * values for the other sizes. We might need to tweak it later depending on the use case.
 */
export const SubMenuPanelWrapper = styled.div`
  position: absolute;
  min-width: 160px;
  max-width: 320px;
  right: 0;
  border: 1px solid ${Colour.Gray[200]};
  border-radius: 10px;
  ${Shadow.Medium1};
  transition: 0.2s opacity ease-out;
  z-index: 1;

  &.small {
    top: 25px;
  }

  &.medium {
    top: 40px;
  }

  &.large {
    top: 68px;
  }

  &.primary {
    right: 24px;
    top: 68px;
  }

  &.invisible {
    opacity: 0;
    visibility: hidden;
  }
`;

export const SubMenuPanel = styled.ul`
  margin: 0;
  padding: 8px 0;
  list-style: none;
  background: ${Colour.Light[100]};
  border-radius: 10px;
`;

export const SubMenuItemWrapper = styled.li`
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ActiveIcon = styled(DawnTick)`
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: ${Colour.Blue[600]};
  flex-shrink: 0;
  pointer-events: none;
  stroke-width: 1;
`;

export const SubMenuItem = styled(TabMenuItem)`
  flex-grow: 1;
  margin: 0;
  padding: 0;
  &.large {
    > a {
      padding: 20px 32px;
    }
  }

  && > a {
    text-align: left;
    width: 100%;
    padding: 12px 24px;
    margin-right: 0;
    font-size: 12px;
    font-weight: 400;
    display: flex;
    align-items: center;

    &:hover:not(.active) {
      color: ${Colour.Gray[800]};
      background: ${Colour.Gray[50]};
      font-weight: 400;
    }

    &.active {
      background: ${Colour.Blue[50]};
      color: ${Colour.Blue[600]};
      font-weight: 500;
      padding-right: 48px;
    }
  }
`;
